/* eslint-disable import/prefer-default-export */
export { default as LoginStepPhone } from './LoginStepPhone';
export { default as LoginStepOTP } from './LoginStepOTP';
export { default as LoginStepAnotherType } from './LoginStepAnotherType';
